import React from "react";
import { Users, Video, NotebookPen, ArrowRight } from "lucide-react";

const offerings = [
  {
    icon: Video,
    title: "Online Classes",
    schedule: "Live on Zoom · Small Groups",
    text: "Six-week guided classes on grief, caregiving, and rebuilding hope — with space for honest questions in a calm, welcoming environment.",
    cta: "View upcoming classes",
  },
  {
    icon: Users,
    title: "Community Workshops",
    schedule: "Workplaces · Care Teams · Community Groups",
    text: "On-site or virtual workshops for groups walking through transition, burnout, or care fatigue. Open to ministry, corporate, and community audiences.",
    cta: "Request a workshop",
  },
  {
    icon: NotebookPen,
    title: "Self-Paced Reflections",
    schedule: "Email-Delivered · Weekly",
    text: "Short, written reflections you can read in five minutes — gentle, practical, and quiet enough for real life.",
    cta: "Get encouragement by email",
  },
];

const Classes = () => {
  return (
    <section
      id="classes"
      data-testid="classes-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-[#D97706]">
              Classes &amp; Workshops
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 leading-tight">
              <span className="gold-underline">Practical teaching</span>, in
              spaces that feel safe.
            </h2>
            <p className="mt-6 text-slate-600 text-base sm:text-lg leading-relaxed">
              Whether you join a small online class or invite Chaplain Derrick
              into your workplace, community group, or care team, each
              gathering is built around the same posture: warmth, honesty, and
              practical hope — open to people of any faith background or none.
            </p>
            <div className="mt-8 rounded-2xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1761843425027-8955b41609dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100"
                alt="A small community group in honest conversation"
                className="w-full h-72 object-cover"
                data-testid="classes-image"
              />
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {offerings.map(({ icon: Icon, title, schedule, text, cta }, idx) => (
              <div
                key={title}
                data-testid={`class-card-${idx}`}
                className={`rounded-2xl border border-slate-100 p-6 lift bg-white flex flex-col ${
                  idx === 0 ? "sm:col-span-2" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="h-10 w-10 rounded-full bg-[#F0F9FF] text-[#0369A1] flex items-center justify-center">
                    <Icon size={18} />
                  </div>
                  <span className="text-[11px] uppercase tracking-widest text-slate-500">
                    {schedule}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-xl text-slate-900">{title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">
                  {text}
                </p>
                <a
                  href="#submit"
                  data-testid={`class-card-cta-${idx}`}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-[#0369A1] hover:text-[#0284C7]"
                >
                  {cta} <ArrowRight size={14} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Classes;
